import {HttpClient} from '@angular/common/http';
import {inject} from '@angular/core';
import {environment} from '../../environments/environment';
import {Observable, share} from 'rxjs';

export type ApiParams = Record<string, string>

export interface ApiOptions {
  params?: ApiParams
}

export abstract class ApiService {
  protected readonly apiBaseUrl = `${environment.apiBaseUrl}/api/v1/`;
  protected readonly http = inject(HttpClient)

  protected get<T>(path: string, {params}: ApiOptions = {}): Observable<T> {
    return this.http.get<T>(
      `${this.apiBaseUrl}${path}`,
      {params}
    ).pipe(share())
  }

  protected post<T>(path: string, body: any, {params}: ApiOptions = {}): Observable<T> {
    return this.http.post<T>(`${this.apiBaseUrl}${path}`, body, {params}).pipe(share())
  }

  protected put<T>(path: string, body: any, {params}: ApiOptions = {}): Observable<T> {
    return this.http.put<T>(`${this.apiBaseUrl}${path}`, body, {params}).pipe(share())
  }

  protected delete<T>(path: string, {params}: ApiOptions = {}): Observable<T> {
    return this.http.delete<T>(
      `${this.apiBaseUrl}${path}`,
      {params}
    ).pipe(share())
  }
}
